export interface UnitOfMeasureFixture {
  code: string
  name: string
  print?: string
}

export const unitsOfMeasureFixture: UnitOfMeasureFixture[] = [
  { code: 'PCS', name: 'Pieces', print: 'pcs' },
  { code: 'HR', name: 'Hour', print: 'h' },
  { code: 'MO', name: 'Month', print: 'mo' },
  { code: 'YR', name: 'Year', print: 'yr' },
  { code: 'KG', name: 'Kilogram', print: 'kg' },
  { code: 'L', name: 'Liter', print: 'l' },
  { code: 'M', name: 'Meter', print: 'm' },
  { code: 'PKG', name: 'Package', print: 'pkg' },
  { code: 'SUB', name: 'Subscription', print: 'sub' },
  { code: 'LIC', name: 'License', print: 'lic' },
]
